import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdBlock from "@/components/AdBlock";
import { Button } from "@/components/ui/button";
import { fireLockAd } from "@/ads/adsterra";
import { Lock, PlayCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdLockModal({ open, onUnlocked }) {
  const [left, setLeft] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    let t;
    api.post("/ads/start").then(({ data }) => {
      if (!data.locked) return onUnlocked();
      if (!data.started || data.remaining === data.seconds) fireLockAd();
      setLeft(data.remaining);
      t = setInterval(() => setLeft((l) => (l > 0 ? l - 1 : 0)), 1000);
    }).catch(() => setLeft(30));
    return () => clearInterval(t);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const unlock = async () => {
    setBusy(true);
    try { await api.post("/ads/complete"); onUnlocked(); toast.success("Chat unlocked. 50 more messages!"); }
    catch (e) { if (e.response?.status === 425) setLeft(3); }
    finally { setBusy(false); }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" data-testid="ad-lock-modal">
      <div className="w-full max-w-sm bg-surface border border-white/10 rounded-2xl p-5 text-center">
        <div className="flex items-center justify-center gap-2 mb-1 text-brand"><Lock className="w-4 h-4" /><span className="text-xs uppercase tracking-widest">Chat paused</span></div>
        <p className="font-heading font-semibold mb-4">You've sent 50 messages. A short sponsored break keeps AFTERHELLO free.</p>
        <AdBlock id="ad-slot-lock-300x250" size="300x250" label="300x250 Sponsored" className="w-[300px] h-[250px] mx-auto" />
        <p className="text-sm text-muted-foreground mt-4" data-testid="ad-lock-countdown">
          {left === null ? "Loading ad…" : left > 0 ? `Chat unlocks in ${left}s…` : "Thanks for watching!"}
        </p>
        <Button data-testid="ad-lock-continue" disabled={left === null || left > 0 || busy} onClick={unlock}
          className="mt-3 w-full h-11 rounded-full bg-brand hover:bg-brand-hover text-white disabled:opacity-40">
          <PlayCircle className="w-4 h-4 mr-2" /> Continue chatting
        </Button>
      </div>
    </div>
  );
}
